import { useNavigate } from "react-router-dom";

import { ErrorsContainer } from "../StyledComponents/AppStyles";

export default function ErrorPage({ setError }) {
  const navigate = useNavigate();

  const reset = () => {
    setError(false);
    navigate("/");
  };

  return (
    <ErrorsContainer>
      <h2>Something went wrong.</h2>
      <p>
        An error has occurred. <u onClick={reset}>Click here to try again.</u>
      </p>
    </ErrorsContainer>
  );
}
